import Plyr from "plyr";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class Strategy{
    
    constructor(element) {
        this._wrapper = element;
        this._videos = document.querySelectorAll('.js-strategy-video');
        this._list = document.querySelector('.js-strategy-list');
        this._left = document.querySelector('.js-strategy-left');
        this._blocks = document.querySelectorAll('.js-strategy-block');
        
        this.greenLight = getComputedStyle(document.body).getPropertyValue('--c-green-light');
        this.pinkLight = getComputedStyle(document.body).getPropertyValue('--c-pink-light');
        
        this.plyrs = [];
        
        this.init();
        this.initTimeline();
        this.bindEvents();
    }
    
    init(){
        app.nodesEach(this._videos, (el) => {
            this.plyrs.push(new Plyr(el));
        });
        
    }
    
    initTimeline(){
        let mm = gsap.matchMedia();
        
        let eventStopVideo = new CustomEvent('strategy:stopvideo');

        mm.add("(min-width:1200px)", () => {
            this._blocks[0].classList.add('is-active');
            app.nodesEach(this._blocks, (el,n) => { // hide last blocks
                if(n > 0){
                    gsap.set(el, {y:'100px', alpha:0});
                }
            });

            this.timeline = new gsap.timeline({
                scrollTrigger:{
                    trigger:this._wrapper,
                    start:'bottom bottom',
                    end:"+=4000",
                    scrub:2,
                    pin:true,
                    markers:false,
                }
            });

            this.timeline.to(this._list,{
                y:() => {
                    let listClientRect = this._list.getBoundingClientRect();
                    let leftClientRect = this._left.getBoundingClientRect();

                    return (Math.round(listClientRect.top + listClientRect.height) - (leftClientRect.top + leftClientRect.height)) * -1;
                },
                ease:"none",
                duration:13,
            }, 0);

            let duration = 2;
            let position = 1;
            let delay = 0;
            app.nodesEach(this._blocks, (el,n) => {
                if(n < this._blocks.length - 1){
                    this.timeline.to(el, {y:'-20px', alpha:0, ease:"none", duration:duration}, position + delay);
                    this.timeline.to(this._blocks[n+1], 
                        {
                            y:'20px', alpha:1, ease:"none", duration:duration, 
                            onStart:() => {
                                app.nodesRemoveClass(this._blocks, 'is-active');
                                this._blocks[n+1].classList.add('is-active');
                                document.dispatchEvent(eventStopVideo);
                            },
                            onReverseComplete:() => {
                                app.nodesRemoveClass(this._blocks, 'is-active');
                                this._blocks[n].classList.add('is-active');
                                document.dispatchEvent(eventStopVideo);
                            }
                        }, position + duration + delay);
                    delay += 1;
                    position += 4;
                }

            });
            this.timeline.to(document.body, {"--c-strategy-color": this.greenLight, ease:'none', duration:4},4);
            this.timeline.to(document.body, {"--c-strategy-color": this.pinkLight, ease:'none', duration:4},8);
        })
    }
    
    bindEvents(){
        document.addEventListener('strategy:stopvideo', (e) => {
          this.plyrs.map((plyr) => {
            plyr.pause();
          })
        });
    }
}